import { AppState } from '../states/app.state';
import { TenantState } from '../states/tenant.state';
import { createSelector } from '@ngrx/store';

const TenantState = (state: AppState) => state.tenant;

export const selectTenant = createSelector(
  TenantState,
  (state: TenantState) => state.tenant
);
